<template>
    <div class="noAccessibleWindowsWarning">
        <div class="warningImage">
            <img src="/img/warning.png"
                 alt="Warning">
        </div>
        <div class="warningTitle">No protection selected</div>
        <div class="warningText">
            Add protection later by viewing
            <div class="trueAdvice"><span class="true">TRUE</span>Advice</div>
        </div>
    </div>
</template>

<script>
import {
    mapActions,
    mapState
} from 'vuex'
export default {
    computed: {
        ...mapState([])
    },
    methods: {
        ...mapActions([])
    },
}

</script>

<style lang="css"></style>
